import React from 'react'
import SimpleAccordion from '../../ui_reusable/SimpleAccordion'
import UniversalLoader from '../../ui_reusable/UniversalLoader'
import { PanelSpecialIndent } from '../../ui_reusable/styles/PlacementMisc.styles'
// Import the generated React Query hook and types
import { useLearningsRetrieve } from '../../../api/generated/endpoints/learning/learning'
// Import Zod schema for runtime validation
import { learningsRetrieveResponse } from '../../../api/generated/validation/learning/learning.zod'
// Import our enhanced validation utility
import { validateAndLog } from '../../../utils/zodDebugger'

const AcademyPage: React.FC = () => {
  // Use the generated React Query hook for type-safe API calls
  const {
    data: learningData,
    isLoading,
    isError,
    error,
  } = useLearningsRetrieve({
    query: {
      staleTime: 0,
      gcTime: 0,
    },
  })

  // Runtime validation with enhanced debugging (one-liner)
  const validatedData = validateAndLog(
    learningsRetrieveResponse,
    learningData,
    'AcademyPage',
  )

  return (
    <>
      <SimpleAccordion id="showAcademyPageAccordion" defaultActiveKey={['1']}>
        <SimpleAccordion.Panel header="Academy" eventKey="1" noCollapse>
          <PanelSpecialIndent>
            <UniversalLoader
              show={isLoading}
              content="Loading academy content..."
            />
            {isError && (
              <div>
                Error:{' '}
                {error instanceof Error
                  ? error.message
                  : 'Failed to load academy content'}
              </div>
            )}
            {!isLoading && !isError && validatedData?.data?.academy && (
              <div
                dangerouslySetInnerHTML={{ __html: validatedData.data.academy }}
              />
            )}
            {!isLoading && !isError && !validatedData?.data?.academy && (
              <div>
                <h3>Citrus Academy</h3>
                <p>
                  Welcome to the Citrus Academy! This section will contain
                  educational content about using the platform.
                </p>
                <p>Academy content coming soon...</p>
                {validatedData && (
                  <p>API Status: {validatedData.status || 'success'}</p>
                )}
              </div>
            )}
          </PanelSpecialIndent>
        </SimpleAccordion.Panel>
      </SimpleAccordion>
    </>
  )
}

export default AcademyPage
